import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, filter, Observable, switchMap } from 'rxjs';
import { EnvironmentService } from '../../environments/environment.service';
import { AuthService } from '../services/auth/auth.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const auth = inject(AuthService);
  const environment = inject(EnvironmentService);

  return auth.getToken().pipe(
    filter((t) => !isAuthProtectedUrl(req.url, environment) || !!t), // Proceed with protected requests only if we have a token
    switchMap((token) =>
      token
        ? next(
            req.clone({
              headers: req.headers.append('Authorization', `Bearer ${token}`),
            }),
          ).pipe(
            catchError((error) => {
              if (error.status === 401 && isAuthProtectedUrl(req.url, environment)) {
                auth.logout();
              }
              throw error;
            }),
          )
        : next(req),
    ),
  );
}

function isAuthProtectedUrl(url: string, environment: EnvironmentService): boolean {
  return [environment.dittoUrl].some((protectedUrl) => url.startsWith(protectedUrl));
}
